module.exports = __webpack_public_path__ + "static/img/banner.f0d57f0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/about/banner.png
// module id = pBjv
// module chunks = 1